import React from "react";
import PropTypes from "prop-types";
import { ColumnPropTypes } from "../../../props";

import { v4 as uuidv4 } from "uuid";

import Placeholder from "../../../../placeholder";

import Tr from "../row/tr";
// import Prefix from "../row/prefix";
// import Suffix from "../row/suffix";

function LoadingBody({ columns, countRows }) {
  let rows = [];
  let cols = [];

  for (let r = 0; r < countRows; r++) {
    cols = [];

    for (let column of columns) {
      cols.push(
        <td key={uuidv4()}>
          {/* {column.title && column.title.length ? (
            <span className="table-content-title">
              <Prefix content={column.prefix} />
              {column.title || ""}
              <Suffix content={column.suffix} />
            </span>
          ) : null} */}

          <span
            className={`table-content-data ${
              !column.title || !column.title.length ? "padding-no-left" : ""
            }`}
          >
            <Placeholder />
          </span>
        </td>
      );
    }

    rows.push(<Tr key={uuidv4()}>{cols}</Tr>);
  }

  return <tbody>{rows}</tbody>;
}

LoadingBody.defaultProps = {
  columns: [],
  countRows: 10
};

LoadingBody.propTypes = {
  // Колонки
  columns: PropTypes.arrayOf(ColumnPropTypes).isRequired,
  countRows: PropTypes.number
};

export default LoadingBody;
